import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { authActions, httpRequestsOnErrorsActions } from "store";
import {
  // ErrMessage,
  InputMain,
  ButtonMain,
} from "components";
import { EmailValidator, FindErrorItem, FindLoad } from "utils";
import { Svg } from "assets";

const ACTION_TYPE = "LOG_IN";

export const LoginModal = () => {
  const { handleSubmit, control, setError, clearErrors, formState:{errors} } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const backError = FindErrorItem(ACTION_TYPE);
  const loader = FindLoad(ACTION_TYPE);
  const errMessageScreen =
    backError?.error === "Check your email to activate your account"
      ? "Check your email to activate your account"
      : backError?.error ===
          "Your account has been inactivated, contact an administrator."
        ? "Your account has been inactivated, contact an administrator."
        : "";

  useEffect(() => {
    return () => {
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
      clearErrors();
    };
  }, []);

  useEffect(() => {
    if (backError?.error === "User account not found or inactive.") {
      setError("email", {
        type: "required",
        message: "User account not found or inactive.",
      });
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    }
    if (
      backError?.error ===
      "User Identification with this resource was not found."
    ) {
      setError("email", {
        type: "required",
        message: "User with this email was not found.",
      });
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    }

    if (backError?.error === "User password does not match") {
      setError("password", {
        type: "required",
        message: "User password does not match",
      });
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    }
  }, [backError]);

  const logInRequest = (data) => {
    dispatch(authActions.logIn(data));
  };

  return (
    <div className="login-wrapper">
      <button className="back-btn" onClick={() => navigate("/")}>
        <Svg.ArrowLeftBack />
        Back
      </button>

      <div className="login-box">
        <Svg.LogInSvg className="login-main-svg" />

        <h3 className="login-title">Welcome to CareTech!</h3>
        <p className="login-description">
          Please enter your details to sign in.
        </p>
        <form className="login-form" onSubmit={handleSubmit(logInRequest)}>
          <InputMain
            variant="outlined"
            name="email"
            control={control}
            placeholder="Enter your email address"
            labelHeader="Email Address"
            rules={{
              required: "Email address is required.",
              pattern: {
                value: EmailValidator,
                message: "Please enter a valid email address.",
              },
            }}
            startAdornment={<Svg.SmsSvg />}
          />
          <InputMain
            variant="outlined"
            name="password"
            type="password"
            showPassword={showPassword}
            control={control}
            placeholder="Password"
            labelHeader="Password"
            rules={{
              required: "Password is required.",
            }}
            onClickIconEnd={() => setShowPassword((prev) => !prev)}
            startAdornment={<Svg.LockPassSvg />}
          />

          {errMessageScreen && (
            <p className="error-message">{errMessageScreen}</p>
          )}

          <div className="flex-end">
            <button
              type={"button"}
              onClick={() => navigate("/forgot")}
              className="forgot-button"
            >
              Forgot Password?
            </button>
          </div>

          <ButtonMain type="submit" load={!!loader?.length} text={"Sign In"} />
        </form>
      </div>
    </div>
  );
};
